var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',[(_vm.loading)?_c('div',{staticClass:"preloader-overlay"},[_c('div',{staticClass:"preloader-card"},[_c('f7-preloader'),_vm._v(" "),_c('div',{staticClass:"preloader-text"},[_vm._v(_vm._s(_vm.$t('loading')))])],1)]):_vm._e(),_vm._v(" "),(_vm.loaded)?_c('div',[_c('FileManager',{attrs:{"file-system":_vm.fs}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }